module.exports = __webpack_public_path__ + "static/media/29170016-min.6fec3dc3.jpg";